import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { AuthService } from './auth.service';
import { ProgressService } from './progress.service';
import { ProgressMilestone } from '../progress/progress-navigation.utils';
import { AppMode } from '../models/app-mode.model';

export interface TourContext {
  appMode: AppMode;
  progress: number;
  companyProfileComplete: boolean;
  digitalConfigurationComplete: boolean;
  hasProperty: boolean;
  isAdmin: boolean;
  isAccountSettingsVisible: boolean;
  hasPermission(permission: string): boolean;
}

interface ProgressResponse {
  progress?: number;
  appMode?: AppMode;
  milestones?: ProgressMilestone[];
  propertiesExist?: boolean;
}

@Injectable({ providedIn: 'root' })
export class TourContextService {
  constructor(
    private readonly authService: AuthService,
    private readonly progressService: ProgressService
  ) {}

  async load(): Promise<TourContext> {
    const response = await firstValueFrom(this.progressService.getProgress()) as unknown as ProgressResponse;
    const milestones = Array.isArray(response?.milestones) ? response.milestones : [];
    const appMode = response?.appMode === 'hospitality' ? 'hospitality' : this.authService.getAppMode();
    const digitalKey = appMode === 'hospitality' ? 'hospitalityLanding' : 'templateHeader';

    return {
      appMode,
      progress: Number(response?.progress || 0),
      companyProfileComplete: !!milestones.find((milestone) => milestone.key === 'companyInfo')?.completed,
      digitalConfigurationComplete: !!milestones.find((milestone) => milestone.key === digitalKey)?.completed,
      hasProperty: !!response?.propertiesExist,
      isAdmin: this.authService.isCurrentUserAdmin(),
      isAccountSettingsVisible: this.authService.getCurrentUserRole() !== 'Admin',
      hasPermission: (permission: string) => this.authService.hasPermission(permission)
    };
  }
}
